module.exports = __webpack_public_path__ + "static/img/cover14.07936ea0.jpg";